export const coreConfigs = {
  id: "core",
};
